import React from 'react';
import { HeaderBar } from './styles';
import logo from '../../assets/images/Galgotias_logo.jpeg';

export default function Header() {
    return (
        <HeaderBar component="header">
            <img src={logo} alt="HUBBLEHOX" style={{ height: 60, objectFit: 'contain' }} />
        </HeaderBar>
    );
}
